import { DealerLocationID } from "./DealerLocation";

export type ShareboxLogID = number;

export enum SHAREBOX_TRIGGERS {
  DoorOpened = 1,
  ReceiverDropKey = 2,
  EmployeePickUpKey = 3,
  EmployeeDropKey = 4,
  ReceiverPickUpKey = 5
}

export enum SHAREBOX_RESULTS {
  Error = 1,
  RegNumberDoNotMatch = 2,
  Completed = 3
}

export interface ShareboxLog {
  created_on: string;
  id: ShareboxLogID; // Sharebox Log ID
  trigger_id: SHAREBOX_TRIGGERS; // Sharebox Event type
  result_id: SHAREBOX_RESULTS; // Result of handling the Sharebox Event
  reason: string | null; // Reason for a Sharebox Event failing
  locker_no: number; // Sharebox Locker number
  subscription_id: number; // Sharebox Subscription ID
  subscription_name: string; // Sharebox Subscription Name
  reservation_id: number; // Sharebox Reservation ID
  event_type: string; // Sharebox Event Type
  event_timestamp: string; // Sharebox Event timestamp
  dealer_location_id: DealerLocationID; // Location Identifier from which the Sharebox Event originates
}
